import type { ComponentProps, FC, ReactNode } from 'react';
import { Link } from '@/core/i18n/routing';

type BaseProps = {
  isExternal?: boolean;
  children: ReactNode;
  className?: string;
  ariaLabel?: string;
  onClick?: () => void;
  isHidden?: boolean;
};

type InternalLinkProps = BaseProps & {
  isExternal?: false;
  href: ComponentProps<typeof Link>['href'];
};

type ExternalLinkProps = BaseProps & {
  isExternal: true;
  href: string;
};

export type LinkProps = InternalLinkProps | ExternalLinkProps;

const CustomLink: FC<LinkProps> = ({
  isExternal,
  children,
  href,
  ariaLabel,
  ...restProps
}) => {
  if (isExternal) {
    return (
      <a
        href={href}
        rel="noopener noreferrer"
        target="_blank"
        aria-label={ariaLabel}
        {...restProps}
      >
        {children}
      </a>
    );
  }

  return (
    <Link href={href} {...restProps} aria-label={ariaLabel}>
      {children}
    </Link>
  );
};

export default CustomLink;
